import { Buffer } from "buffer";

export const base64ToPdf = (base64String, fileType) => {
  let typeFile = fileType === "pdf" ? "application/pdf" : "image/png";
  const buffer = Buffer.from(base64String, "base64");
  const url = URL.createObjectURL(new Blob([buffer], { type: typeFile }));
  return url;
};
